import { createSlice } from "@reduxjs/toolkit";

// Define the TS type for the counter slice's state
export interface DashboardState {
	todoFilters: {
		name: string;
		type: string;
		stage: string;
		team: string;
	};
	trialBookFilters: {
		name: string;
		type: string;
		stage: string;
		team: string;
		bookType: string;
	};
	fieldRepFilters: {
		team: string;
		type: string;
	};
}

// Define the initial value for the slice state
const initialState: DashboardState = {
	todoFilters: {
		name: "",
		type: "",
		stage: "",
		team: "",
	},
	trialBookFilters: {
		name: "",
		type: "",
		stage: "",
		team: "",
		bookType: "",
	},
	fieldRepFilters: {
		team: "",
		type: "",
	},
};
export const dashboardSlice = createSlice({
	name: "dashboardState",
	initialState,
	reducers: {
		setTodoFilters: (state, action) => {
			state.todoFilters = action.payload;
		},
		resetTodoFilter: (state) => {
			state.todoFilters = initialState.todoFilters;
		},
		setTrialFilters: (state, action) => {
			state.trialBookFilters = action.payload;
		},
		resetTrialFilter: (state) => {
			state.trialBookFilters = initialState.trialBookFilters;
		},
		setFieldRepFilters: (state, action) => {
			state.fieldRepFilters = action.payload;
		},
		resetFieldRepFilter: (state) => {
			state.fieldRepFilters = initialState.fieldRepFilters;
		},
	},
});

// Export the generated action creators for use in components
export const { setTodoFilters, resetTodoFilter, setTrialFilters, resetTrialFilter, setFieldRepFilters, resetFieldRepFilter } = dashboardSlice.actions;

// Export the slice reducer for use in the store configuration
export default dashboardSlice.reducer;
